(function() {
    'use strict';

    angular
        .module('platformApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('homeFirst', {
            parent: 'app',
            url: '/homeFirst?key&uuid&phone',
            data: {
                authorities: []
            },
            views: {
                'navbar@': {
                    templateUrl: 'app/entities/home-first/home-first.html',
                    controller: 'HomeFirstController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
